<script>
import ModelFilter from "@/router/views/sale_invoices/filter";
import ModelIndex from "../models/index-v3";

export default {
  extends: ModelIndex,
  components: {
    ModelFilter
  },
  page: {
    title: "Sale Invoices",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t('menuitems.sale_invoices.text'))
      }
    },
    resourceRoute: {default: 'sale_invoices'},
    modelVariable: {default: 'sale_invoice'},
    denyCreate: {
      type: Boolean, default: true,
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('sale_invoices.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('sale_invoices.singular')),
          href: "/sale_invoices",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'sale_order.ticket_id',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        ticket_id__in: {
          type: Array,
          label: this.lodash.startCase(this.$t('sale_invoices.ticket_id')),
          operator: 'in',
          input_component: 'ticket-multiselect-ajax',
        },
        paid_at__between: {
          type: Array,
          label: this.lodash.startCase(this.$t("sale_invoices.paid_at")),
          operator: "between",
          input_component: "datepicker-range",
          opens: "left",
        },
        "from_bank_account.customer_id__in": {
          type: Array,
          label: this.lodash.startCase(this.$t("purchase_payments.from")),
          operator: "in",
            input_component: "supplier-multiselect-ajax",
        },
        payment_status: {
          type: Array,
          label: this.lodash.startCase("Status Penerimaan"),
          input_component: "purchase-payment-status-select",
        }
        // 'paymentable.ticketable.ticket_id': {
        //   type: Array,
        //   label: this.lodash.startCase(this.$t('sale_invoices.ticket_id')),
        //   operator: 'in',
        //   input_component: 'ticket-multiselect-ajax',
        // },
        // paid_at: {
        //   type: Array,
        //   label: this.lodash.startCase(this.$t('sale_invoices.paid_at')),
        //   operator: 'between',
        //   input_component: 'datepicker-range',
        // },
        // 'from_bank_account.customer_id': {
        //   type: Array,
        //   label: this.lodash.startCase(this.$t('sale_invoices.from')),
        //   operator: 'in',
        //   input_component: 'supplier-multiselect-ajax',
        //   params: { type__in: 'brs,lcs,processing'}
        // },
        // nominal: {
        //   type: Array,
        //   label: this.lodash.startCase(this.$t('sale_invoices.nominal')),
        //   operator: 'between',
        //   input_component: 'number-range',
        // },
        // 'payment_status': {
        //   type: Array,
        //   label: this.lodash.startCase('Status Pembayaran'),
        //   input_component: 'sales-invoice-payment-status-select',
        // },
      },
      model: this.modelVariable
    }
  },
  computed: {
    columns() {
      return {
        ['sale_invoice']: [
          // { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
          {
            key: 'sale_order.ticket_id',
            label: this.lodash.startCase(this.$t('sale_invoices.ticket_id')),
            thStyle: {width: '75px'},
            sortable: true,
            component: {
              props: ['item'],
              computed: {
                customLabel() {
                  return `${this.item.sale_order.ticket_id}: ${this.$t(`tickets.customer_types.${this.item.sale_order.ticket.customer_type}`)}`
                }
              },
              template: '<router-link :to="`/tickets/${(item.sale_order || {}).ticket_id}`">{{ customLabel }}</router-link>'
            }
          },
          {
            key: 'paid_at',
            label: this.lodash.startCase(this.$t('sale_invoices.paid_at')),
            thStyle: {width: '125px'},
            thClass: 'text-center',
            sortable: true,
            formatter: value => this.$moment.utc(value).local().format('DD MMM YYYY'),
          },
          {
            key: 'from_bank_account',
            label: this.lodash.startCase(this.$t('sale_invoices.from')),
            thStyle: {maxWidth: '250px'},
            thClass: 'text-center',
            // sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/customers/${(item || {}).from_bank_account.customer_id}`">{{ `${item.from_bank_account.customer.name } - ${ item.from_bank_account.account_number} - ${item.from_bank_account.bank.name}` }}</router-link>'
            }
          },
          // {
          //   key: 'to_bank_account',
          //   label: this.lodash.startCase(this.$t('sale_invoices.to')),
          //   thStyle: { maxWidth: '250px' },
          //   thClass: 'text-center',
          //   sortable: true,
          //   component: {
          //     props: ['item'],
          //     template: '<router-link :to="`/customers/${(item || {}).to_bank_account.customer_id}`">{{ `${item.to_bank_account.customer.name } - ${ item.to_bank_account.account_number} - ${item.to_bank_account.bank.name}` }}</router-link>'
          //   }
          // },
          {
            key: 'debit',
            label: this.lodash.startCase(this.$t('sale_invoices.nominal')),
            thStyle: {width: '150px'},
            thClass: "text-center",
            tdClass: "text-end",
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('$ 0,0.[00]');
            }
          },
          {
            key: 'status',
            label: this.lodash.startCase(this.$t('sale_invoices.payment_status')),
            item: this.model,
            thClass: "text-center",
            thStyle: {width: '150px'},
            component: {
              props: ['item'],
              computed: {
                isPaidOff() {
                  return this.item.sale_order.remaining_receivable <= 0
                },
                badgeClass() {
                  return {
                    paid: this.isPaidOff,
                    unpaid: !this.isPaidOff,
                  }
                },
                status() {
                  if (this.item.sale_order.remaining_receivable === this.item.sale_item_total) {
                    return this.lodash.upperFirst(this.$t('sale_invoices.status.unpaid'))
                  } else if (this.item.sale_order.remaining_receivable > 0) {
                    return this.lodash.upperFirst(this.$t('sale_invoices.status.paid {nominal}', {
                      nominal: this.$numeral(this.item.sale_order.remaining_receivable).format('$ 0,0.[00]'),
                    }));
                  } else {
                    return this.lodash.upperFirst(this.$t('sale_invoices.status.paid'))
                  }
                }
              },
              template: '<div><payment-badge :class="badgeClass">{{ status }}</payment-badge></div>'
            }
          },
          // {
          //   key: 'description',
          //   label: this.lodash.startCase(this.$t('sale_invoices.description')),
          //   thClass: "text-center",
          //   thStyle: { width: '150px' },
          //   component: {
          //     props: ['item'],
          //     computed: {
          //       descriptionsTruncate() {
          //         return this.item.description ? this.$options.filters.truncate(this.item.description, 65) : ''
          //       }
          //     },
          //     template: '<div v-html="descriptionsTruncate"></div>'
          //   }
          // },
          {
            key: 'creator.name',
            label: this.lodash.startCase(this.$t('CreatedBy')),
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: {minWidth: '50px'},
            style: {width: '20%'},
            formatter: (value) => this.lodash.startCase(value)
          },
          {key: 'action', label: this.$t('Action'), class: 'text-center', style: {width: '1%'}}
        ],
      };
    },
  },
  methods: {
    getModelName(value) {
      return value['order_id'];
    },
    delete(value) {
      return this.$axios.delete(`/payments/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/sale_payments', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          with: [
            'creator',
            'from_bank_account.bank',
            'from_bank_account.customer',
            'to_bank_account.bank',
            'to_bank_account.customer',
            'paymentable.tickets',
            'sale_order.ticket',
          ].join(','),
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.$route.params,
          ...this.filterParams
        }
      }).then((response) => {
        const {data: {data, meta}} = response;
        this.models = data.map((datum) => ({
          ...datum,
          ...this.modelPolicy(),
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.stats = [
          {
            title: this.lodash.startCase(this.$t('sale_invoices.count')),
            value: this.$numeral(this.total).format('0,0 a'),
            valueTitle: this.$numeral(this.total).format('0,0'),
            icon: 'bx bx-copy-alt'
          },
        ]

        return response;
      }).catch((error) => this.failedAlert(error));
    },
    modelPolicy() {
      return {
        _denyShow: false,
        _denyEdit: true,
        _denyDelete: true,
      }
    },
  },
};
</script>
